import {
  fork,
  take,
  call,
  put,
  cancel,
  race,
  takeEvery,
  takeLatest,
  all,
} from "redux-saga/effects";

import { sagasActions } from "../actions/index";

import { get, post, postAuth, getAuth, remove, update } from "../Api";

import { notification } from "../utils/notifications";
import { redirectToDashboard, redirectToVerification } from "../utils/auth";

const jumioCallbackUrl = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_JUMIO_CALLBACK_URL;

// Log in
function* requestSignInSaga() {
  yield takeLatest(`${sagasActions.requestSignIn}`, requestSignInCall);
}

function* requestSignInCall(data) {
  try {
    const response = yield call(
      post,
      data.payload.credentials,
      "login",
      "uapi"
    );

    if (response.status === 429) {
      yield put(
        sagasActions.pushNotification({
          message: "_rateLimiting",
          type: "error",
        })
      );
      yield put(sagasActions.fillLoginError(true));
      return;
    }

    if (response.error) {
      if (response.status === 500) {
        yield put(sagasActions.fillAccount(null));
        return yield put(
          sagasActions.pushNotification({
            message: "somethingWentWrong",
            type: "error",
          })
        );
      }

      if (response.error.errors.base[0].includes("new IP address")) {
        yield put(sagasActions.showIPForm(true));
      } else {
        yield notification(response.error.errors.base[0], "error");
      }

      yield put(sagasActions.fillLoginError(true));
      return;
    }

    localStorage.token = response.data.token;

    const userTerms = yield call(
      getAuth,
      {
        type: "primary",
      },
      "terms/details",
      "uapi"
    );

    if (userTerms.data) {
      if (
        userTerms.data.current_terms_version <=
        userTerms.data.user_terms_version
      ) {
        yield put(sagasActions.fillAccount(response.data));
      } else {
        localStorage.token = "";
        yield put(sagasActions.fillAcceptNewTerms(true));
        yield put(sagasActions.fillTemporaryAcc(response.data));
      }
    }
  } catch (e) {
    console.log("ERROR_LOGIN ->", e);
    return yield put(sagasActions.fillAccount(null));
  }
}

// Accept New Terms
function* requestAcceptNewTermsSaga() {
  yield takeLatest(
    `${sagasActions.requestAcceptNewTerms}`,
    requestAcceptNewTermsCall
  );
}

function* requestAcceptNewTermsCall(data) {
  try {
    yield put(sagasActions.fillAccount(data.payload));

    const response = yield call(
      postAuth,
      {
        type: "primary",
      },
      "terms/accept",
      "uapi"
    );

    if (response.status === 200) {
      if (data.payload.level === 0) {
        redirectToVerification();
      } else {
        console.log("ts2_");
        redirectToDashboard();
      }
    }
  } catch (e) {
    console.log("ERROR_REQUEST_NEW_TERMS_ACCEPT ->", e);
    yield put(sagasActions.fillAccount(null));
  }
}

// Sign Up
function* signUpRequestSaga() {
  yield takeLatest(`${sagasActions.signUpRequest}`, signUpRequestCall);
}

function* signUpRequestCall(data) {
  try {
    const response = yield call(post, data.payload, "accounts", "uapi");

    if (response.error) {
      yield put(
        sagasActions.handleSignUpRequest({
          success: false,
          account: null,
          errors: response.errors,
        })
      );

      if (response.error.errors.country) {
        return notification(response.error.errors.country, "error");
      }

      if (response.error.errors.email) {
        notification(`Email ${response.error.errors.email}`, "error");
      } else {
        notification(response.error.errors.base[0], "error");
      }

      return;
    }

    yield put(
      sagasActions.handleSignUpRequest({
        success: true,
        account: response.data,
        errors: null,
      })
    );

    yield put(sagasActions.fillAccount(response.data));
  } catch (e) {
    console.log("E_SIGN_UP_REQUEST ->", e);
  }
}

// Sign Out
function* requestSignOutSaga() {
  yield takeLatest(`${sagasActions.requestSignOut}`, requestSignOutCall);
}

function* requestSignOutCall() {
  try {
    const response = yield call(remove, {}, "tokens/current", "uapi");

    if (response.status === 204) {
      localStorage.token = "";
      window.location.reload();
    }
  } catch (e) {
    console.log("E_REQUEST_SIGN_OUT ->", e);
  }
}

// Get Terms version
function* getTermsVersionSaga() {
  yield takeLatest(`${sagasActions.getTermsVersion}`, getTermsVersionCall);
}

function* getTermsVersionCall() {
  try {
    const response = yield call(get, {}, "terms_version.json", "ops");

    if (response.data) {
      yield put(sagasActions.fillTermsVersion(response.data));
    }
  } catch (e) {
    console.log("E_GET_TERMS_VERSION ->", e);
  }
}

// Get Account
function* getAccountSaga() {
  yield takeLatest(`${sagasActions.getAccount}`, getAccountCall);
}

function* getAccountCall() {
  try {
    const response = yield call(getAuth, {}, "me", "uapi");

    if (response.error) {
      return yield put(sagasActions.fillAccount(null));
    }

    yield put(sagasActions.fillAccount(response.data));
  } catch (e) {
    console.log("ERROR_LOGIN", e);
  }
}

// Update Account
function* updateAccountSaga() {
  yield takeLatest(`${sagasActions.updateAccount}`, updateAccountCall);
}

function* updateAccountCall(data) {
  try {
    const response = yield call(update, data.payload, "account", "uapi");

    if (response.status === 204) {
      yield call(getAccountCall);
    }
  } catch (e) {
    console.log("E_UPDATE_ACCOUNT ->", e);
  }
}

// Update Profile
function* updateProfileSaga() {
  yield takeLatest(`${sagasActions.updateProfile}`, updateProfileCall);
}

function* updateProfileCall(data) {
  try {
    yield put(
      sagasActions.uploadLevel6finished({
        sent: true,
        finished: false,
        error: false,
      })
    );
    const response = yield call(update, data.payload, "profile", "uapi");

    console.log("RESPONSE PROFILE", response);

    if (response.status === 201) {
      yield call(getAccountCall);
      yield put(
        sagasActions.uploadLevel6finished({
          sent: true,
          finished: true,
          error: false,
        })
      );
    } else {
      yield put(
        sagasActions.uploadLevel6finished({
          sent: true,
          finished: true,
          error: true,
        })
      );
    }
  } catch (e) {
    console.log("E_UPDATE_PROFILE ->", e);
  }
}

// Api Keys
function* requestApiKeySaga() {
  yield takeLatest(`${sagasActions.requestApiKey}`, requestApiKeyCall);
}

function* requestApiKeyCall(data) {
  try {
    const response = yield call(postAuth, data.payload, "api_keys", "uapi");

    if (response.status === 201) {
      yield put(sagasActions.fillNewApiKey(response.data));
      yield call(fetchApiKeysCall);
      yield call(fetchApiSummaryCall);
    }

    if (response.error) {
      if (response.error.errors.base[0] === "Invalid OTP.") {
        yield put(
          sagasActions.pushNotification({ message: "wrongOtp", type: "error" })
        );

        return;
      }

      if (response.error.errors.base[0] === "Used OTP.") {
        yield put(
          sagasActions.pushNotification({ message: "wrongOtp", type: "error" })
        );

        return;
      }

      if (
        response.error.errors.base[0] ===
        "User API keys limit exceeded. Maximum 10 active API keys allowed."
      ) {
        yield put(
          sagasActions.pushNotification({
            message: "_apiKeysLimit",
            type: "error",
          })
        );

        return;
      }

      yield put(
        sagasActions.fillNewApiKey({
          exp: null,
          jti: null,
          token: null,
          scopes: null,
          updated: false,
        })
      );

      yield put(
        sagasActions.pushNotification({ message: "_tryLater", type: "error" })
      );
    }
  } catch (e) {
    console.log("E_REQUEST_API ->", e);
  }
}

function* fetchApiKeysSaga() {
  yield takeLatest(`${sagasActions.fetchApiKeys}`, fetchApiKeysCall);
}

function* fetchApiKeysCall() {
  try {
    const response = yield call(getAuth, {}, "api_keys", "uapi");

    if (response.data) {
      yield put(sagasActions.fillApiKeys(response.data));
    }
  } catch (e) {
    console.log("E_FETCH_API_KEYS ->", e);
  }
}

function* deleteApiKeySaga() {
  yield takeLatest(`${sagasActions.deleteApiKey}`, deleteApiKeyCall);
}

function* deleteApiKeyCall(data) {
  try {
    const response = yield call(remove, {}, "api_keys/" + data.payload, "uapi");

    if (response.status === 200) {
      yield put(
        sagasActions.pushNotification({
          message: "_keyRevoked",
          type: "success",
        })
      );

      yield call(fetchApiKeysCall);
      yield call(fetchApiSummaryCall);
    }
  } catch (e) {
    console.log("E_DELETE_API_KEY ->", e);
  }
}

// Fetch API Keys summary
function* fetchApiSummarySaga() {
  yield takeLatest(`${sagasActions.fetchApiSummary}`, fetchApiSummaryCall);
}

function* fetchApiSummaryCall() {
  try {
    const response = yield call(getAuth, {}, "api_keys/summary", "uapi");

    if (response.data) {
      yield put(sagasActions.fillApiSummary(response.data));
    }
  } catch (e) {
    console.log("E_FETCH_API_SUMMARY ->", e);
  }
}

// Fetch phone codes
function* fetchPhoneCodesSaga() {
  yield takeLatest(`${sagasActions.fetchPhoneCodes}`, fetchPhoneCodesCall);
}

function* fetchPhoneCodesCall() {
  try {
    const response = yield call(get, {}, "phones/codes", "uapi");

    if (response.data) {
      yield put(sagasActions.fillPhoneCodes(response.data));
    }
  } catch (e) {
    console.log("E_FETCH_PHONE_CODES ->", e);
  }
}

// Fetch nationalities
function* fetchNationalitiesSaga() {
  yield takeLatest(
    `${sagasActions.fetchNationalities}`,
    fetchNationalitiesCall
  );
}

function* fetchNationalitiesCall() {
  try {
    const response = yield call(get, {}, "nationalities", "uapi");

    if (response.data) {
      yield put(sagasActions.fillNationalities(response.data));
    }
  } catch (e) {
    console.log("E_FETCH_NATIONALITIES ->", e);
  }
}

// Fetch Countries
function* fetchCountriesSaga() {
  yield takeLatest(`${sagasActions.fetchCountries}`, fetchCountriesCall);
}

function* fetchCountriesCall() {
  try {
    const response = yield call(get, {}, "countries", "uapi");

    if (response.data) {
      yield put(sagasActions.fillCountries(response.data));
    }
  } catch (e) {
    console.log("E_FETCH_COUNTRIES ->", e);
  }
}

// Fetch Occupations
function* fetchOccupationsSaga() {
  yield takeLatest(`${sagasActions.fetchOccupations}`, fetchOccupationsCall);
}

function* fetchOccupationsCall() {
  try {
    const response = yield call(get, {}, "occupations", "uapi");
    if (response.data) {
      yield put(sagasActions.fillOccupations(response.data));
    }
  } catch (e) {
    console.log("E_FETCH_OCCUPATIONS ->", e);
  }
}

// Submit IP Confirmation
function* submitIpConfirmationSaga() {
  yield takeLatest(
    `${sagasActions.submitIpConfirmation}`,
    submitIpConfirmationCall
  );
}

function* submitIpConfirmationCall(data) {
  try {
    const response = yield call(
      post,
      data.payload,
      "ip_verifications/verify",
      "uapi"
    );

    if (response.status === 204) {
      yield put(sagasActions.fillIpConfirmation("ip_confirmed"));
    } else {
      yield put(sagasActions.fillIpConfirmation("invalid_code"));
    }
  } catch (e) {
    console.log("E_IP_CONFIRMATION", e);
  }
}

// Enable & Disable OTP
function* enableOtpSaga() {
  yield takeLatest(`${sagasActions.enableOtp}`, enableOtpCall);
}

function* enableOtpCall(data) {
  try {
    const response = yield call(postAuth, data.payload, "2fa", "uapi");

    if (response.error && response.error.errors.base) {
      if (response.error.errors.base[0] === "Invalid OTP.") {
        yield put(
          sagasActions.pushNotification({ message: "wrongOtp", type: "error" })
        );
      }
    }

    if (response.status === 204) {
      if (data.payload.otp) {
        yield put(sagasActions.fillOtpEnabled(true));
      }

      yield put(
        sagasActions.pushNotification({
          message: "otpEnabled",
          type: "success",
        })
      );
      yield call(getAccountCall);

      return;
    }

    if (response.data) {
      yield put(sagasActions.fillOtpSecret(response.data.secret));
    }
  } catch (e) {
    console.log("E_ENABLE_OTP ->", e);
  }
}

function* disabledOtpSaga() {
  yield takeLatest(`${sagasActions.disableOtp}`, disabledOtpCall);
}

function* disabledOtpCall(data) {
  try {
    const response = yield call(remove, { otp: data.payload }, "2fa", "uapi");

    if (response.error && response.error.errors.base) {
      if (response.error.errors.base[0] === "Invalid OTP.") {
        yield put(
          sagasActions.pushNotification({ message: "wrongOtp", type: "error" })
        );
      }
    }

    if (response.status === 204) {
      yield put(
        sagasActions.pushNotification({
          message: "otpDisabled",
          type: "success",
        })
      );
      yield put(sagasActions.fillOtpDisabled(true));
      yield call(getAccountCall);
    }
  } catch (e) {
    console.log("E_DISABLE_OTP ->", e);
  }
}

// Upload To Jumio
function* uploadToJumioSaga() {
  yield takeLatest(`${sagasActions.uploadToJumio}`, uploadToJumioCall);
}

function* uploadToJumioCall(data) {
  try {
    yield put(
      sagasActions.uploadJumioFinished({
        sent: true,
        finished: false,
        error: false,
      })
    );
    const response = yield call(
      postAuth,
      { ...data.payload, callbackUrl: jumioCallbackUrl },
      "performNetverify",
      "jumio"
    );

    if (response.status === 200) {
      yield call(postAuth, {}, "jumio/completed", "uapi");
      yield put(
        sagasActions.uploadJumioFinished({
          sent: true,
          finished: true,
          error: false,
        })
      );

      // yield call(getAccountCall);
    } else {
      yield put(
        sagasActions.uploadJumioFinished({
          sent: true,
          finished: true,
          error: true,
        })
      );
    }
  } catch (e) {
    console.log("E_UPLOAD_TO_JUMIO ->", e);
  }
}

// Change Password
function* submitChangePasswordSaga() {
  yield takeLatest(
    `${sagasActions.submitChangePassword}`,
    submitChangePasswordCall
  );
}

function* submitChangePasswordCall(data) {
  try {
    const response = yield call(update, data.payload, "password", "uapi");

    if (response.error) {
      let message;

      switch (response.error.errors.base[0]) {
        case "Current password is not valid.":
          message = "currentWrongPassword";
          break;
        case "Invalid OTP.":
          message = "wrongOtp";
          break;
        default:
          message = "somethingWentWrong";
      }

      yield put(
        sagasActions.pushNotification({
          message: message,
          type: "error",
        })
      );
    }

    if (response.status === 204) {
      yield put(
        sagasActions.pushNotification({
          message: "passwordChanged",
          type: "success",
        })
      );
      window.location.reload();
    }
  } catch (e) {
    console.log("E_CHANGE_PASSWORD ->", e);
  }
}

// Password Reset
function* requestPasswordResetSaga() {
  yield takeLatest(
    `${sagasActions.requestPasswordReset}`,
    requestPasswordResetCall
  );
}

function* requestPasswordResetCall(data) {
  try {
    const response = yield call(
      post,
      data.payload,
      "password/reset/initiate",
      "uapi"
    );

    if (response.status === 204) {
      yield put(sagasActions.passwordResetInitiated(true));
      return;
    }

    if (response.error) {
      if (response.error.errors.base) {
        yield put(
          sagasActions.pushNotification({
            message: response.error.errors.base[0],
            type: "error",
          })
        );
        return;
      }

      yield put(
        sagasActions.pushNotification({
          message: "somethingWentWrong",
          type: "error",
        })
      );
    }
  } catch (e) {
    console.log("E_PASSWORD_RESET_REQUEST ->", e);
  }
}

function* completePasswordResetSaga() {
  yield takeLatest(
    `${sagasActions.completePasswordReset}`,
    completePasswordResetCall
  );
}

function* completePasswordResetCall(data) {
  try {
    const response = yield call(
      post,
      data.payload.pass_reset,
      "password/reset/complete",
      "uapi"
    );

    if (response.status === 204) {
      yield put(sagasActions.passwordResetComplete(true));
      yield put(sagasActions.passwordResetInitiated(false));
      yield put(
        sagasActions.pushNotification({
          message: "passwordChanged",
          type: "success",
        })
      );
    } else {
      if (response.error.errors.base) {
        data.payload.callback(2);

        yield put(
          sagasActions.pushNotification({
            message: response.error.errors.base[0],
            type: "error",
          })
        );
        return;
      }

      yield put(
        sagasActions.pushNotification({
          message: "somethingWentWrong",
          type: "error",
        })
      );
    }
  } catch (e) {
    console.log("E_COMPLETE_PASS_RESET ->", e);
  }
}

// Documents Upload
function* uploadFileSaga() {
  yield takeEvery(`${sagasActions.uploadFile}`, uploadFileCall);
}

function* uploadFileCall(data) {
  try {
    const response = yield call(postAuth, data.payload, "documents", "uapi");

    if (response.data) {
      yield put(
        sagasActions.pushNotification({
          message: "fileUploaded",
          type: "success",
        })
      );

      yield put(sagasActions.fileUploaded(true));
    }

    yield call(getAccountCall);
  } catch (e) {
    console.log("E_UPLOAD_FILE ->", e);
  }
}

// Email Verification
function* submitVerificationCodeSaga() {
  yield takeLatest(
    `${sagasActions.submitVerificationCode}`,
    submitVerificationCodeCall
  );
}

function* submitVerificationCodeCall(data) {
  try {
    const response = yield call(
      post,
      data.payload,
      "email_confirmations/confirm",
      "uapi"
    );

    if (response.error) {
      let readableError = response.error.errors.base[0]
        .split(" ")
        .join("_")
        .replace(".", "")
        .toLowerCase();

      yield put(sagasActions.emailVerificationError(readableError));

      return yield put(
        sagasActions.pushNotification({
          message: readableError,
          type: "error",
        })
      );
    }

    if (response.status === 204) {
      yield put(
        sagasActions.pushNotification({
          message: "emailConfirmed",
          type: "success",
        })
      );
      yield put(sagasActions.fillVerificationResponse(true));
      yield call(getAccountCall);
    }
  } catch (e) {
    console.log("E_SUBMIT_VERIFICATION_CODE ->", e);
  }
}

// Resend Verification code
function* resendVerificationCodeSaga() {
  yield takeLatest(
    `${sagasActions.resendVerificationCode}`,
    resendVerificationCodeCall
  );
}

function* resendVerificationCodeCall(data) {
  try {
    const response = yield call(
      post,
      data.payload,
      "email_confirmations/resend",
      "uapi"
    );

    if (response.status === 204) {
      yield put(
        sagasActions.fillResendEmailCode({ codeSent: true, error: false })
      );
    } else {
      yield put(
        sagasActions.fillResendEmailCode({ codeSent: false, error: true })
      );
    }
  } catch (e) {
    console.log("E_RESEND_VERIFICATION_CODE ->", e);
  }
}

// Verify Phone
function* verifyPhoneSaga() {
  yield takeLatest(`${sagasActions.verifyPhone}`, verifyPhoneCall);
}

function* verifyPhoneCall(data) {
  try {
    const response = yield call(postAuth, data.payload, "phones", "uapi");

    if (response.data) {
      if (response.data.verification_method) {
        yield put(
          sagasActions.fillPhoneResponse({
            codeSent: true,
            method: response.data.verification_method,
            error: null,
            code_verified: false,
          })
        );
      } else {
        yield put(
          sagasActions.fillPhoneResponse({
            codeSent: false,
            method: null,
            error: null,
            code_verified: true,
          })
        );
      }
    } else {
      if (response.status === 429) {
        yield put(
          sagasActions.fillPhoneResponse({
            codeSent: false,
            error: "_tooManyRequests",
            method: null,
            code_verified: false,
          })
        );
      } else {
        yield put(
          sagasActions.fillPhoneResponse({
            codeSent: false,
            error: response.error.errors,
            method: null,
            code_verified: false,
          })
        );
      }
    }
  } catch (e) {
    console.log("E_VERIFY_PHONE", e);
  }
}

// Fetch Territories
function* fetchTerritoriesSaga() {
  yield takeLatest(`${sagasActions.fetchTerritories}`, fetchTerritoriesCall);
}

function* fetchTerritoriesCall(data) {
  try {
    const response = yield call(
      get,
      {},
      `territories?country=${data.payload.code}`,
      "uapi"
    );

    if (response.data) {
      yield put(sagasActions.fillTerritories(response.data));
    }
  } catch (e) {
    console.log("E_FETCH_TERRITORIES ->", e);
  }
}

// Profile Submission
function* submitProfileSaga() {
  yield takeLatest(`${sagasActions.submitProfile}`, submitProfileCall);
}

function* submitProfileCall(data) {
  try {
    const response = yield call(postAuth, data.payload, "profile", "uapi");

    if (response.error) {
      if (response.error.errors.base) {
        if (
          response.error.errors.base[0].split(" ").includes("Unfortunately")
        ) {
          yield put(sagasActions.similarProfileToggle(true));
          yield call(getAccountCall);
        }
      }

      if (response.error.errors.birthdate) {
        yield put(
          sagasActions.pushNotification({
            message: "_underageError",
            type: "error",
          })
        );
      } else {
        yield put(
          sagasActions.pushNotification({
            message: "somethingWentWrong",
            type: "error",
          })
        );
      }

      yield put(
        sagasActions.fillProfileResponse({ isProfileSubmitted: false })
      );
    }

    if (response.data) {
      yield put(sagasActions.fillProfileResponse({ isProfileSubmitted: true }));
      yield call(getAccountCall);
    }
  } catch (e) {
    console.log("E_SUBMIT_PROFILE ->", e);
  }
}

// Fetch ID Types
function* getAcceptedIDTypesSaga() {
  yield takeLatest(
    `${sagasActions.getAcceptedIDtypes}`,
    getAcceptedIDTypesCall
  );
}

function* getAcceptedIDTypesCall() {
  try {
    const response = yield call(getAuth, {}, "acceptedIdTypes", "jumio");

    if (response.data) {
      yield put(sagasActions.fillIDtypes(response.data.jumio.response_data));
    }
  } catch (e) {
    console.log("E_GET_ID_TYPES ->", e);
  }
}

/////////////////////////////////////////////////////////////////////////////////
//////////////// INSITUTIONS ////////////////////////////////////////////////////

// Fetch Institution
function* fetchInstitutionSaga() {
  yield takeLatest(`${sagasActions.fetchInstitution}`, fetchInstitutionCall);
}

function* fetchInstitutionCall() {
  try {
    const response = yield call(getAuth, {}, "institution", "uapi");

    if (response.data) {
      yield put(sagasActions.fillInstitution(response.data));
    } else {
      yield put(sagasActions.fillInstitution(null));
    }
  } catch (e) {
    console.log("E_FETCH_INSTITUTION ->", e);
  }
}

// Create Institution
function* createInstitutionSaga() {
  yield takeLatest(`${sagasActions.createInstitution}`, createInstitutionCall);
}

function* createInstitutionCall(data) {
  try {
    const response = yield call(postAuth, data.payload, "institution", "uapi");

    if (response.status === 201) {
      yield put(sagasActions.fillInstitution(response.data));
    }
  } catch (e) {
    yield put(
      sagasActions.pushNotification({
        message: "somethingWentWrong",
        type: "error",
      })
    );
    console.log("E_CREATE_INSTITUTION ->", e);
  }
}

// Submit Bank Details
function* submitBankDetailsSaga() {
  yield takeLatest(`${sagasActions.submitBankDetails}`, submitBankDetailsCall);
}

function* submitBankDetailsCall(data) {
  try {
    const response = yield call(
      postAuth,
      data.payload,
      "institution/banks",
      "uapi"
    );

    if (response.data) {
      yield put(sagasActions.fillInstitution(response.data));
    }
  } catch (e) {
    yield put(
      sagasActions.pushNotification({
        message: "somethingWentWrong",
        type: "error",
      })
    );
    console.log("E_BANK_DETAILS ->", e);
  }
}

// Submit Directors
function* submitInstitutionDirectorsSaga() {
  yield takeLatest(
    `${sagasActions.submitInstitutionDirectors}`,
    submitInstitutionDirectorsCall
  );
}

function* submitInstitutionDirectorsCall(data) {
  try {
    const response = yield call(
      postAuth,
      data.payload,
      "institution/representatives",
      "uapi"
    );

    if (response.data) {
      yield put(sagasActions.fillInstitution(response.data));
    }
  } catch (e) {
    yield put(
      sagasActions.pushNotification({
        message: "somethingWentWrong",
        type: "error",
      })
    );
    console.log("E_INSTITUTION_DIRECTORS ->", e);
  }
}

// Submit Institution Documents
function* submitInstitutionDocumentsSaga() {
  yield takeLatest(
    `${sagasActions.submitInstitutionDocuments}`,
    submitInstitutionDocumentsCall
  );
}

function* submitInstitutionDocumentsCall(data) {
  try {
    const response = yield call(
      postAuth,
      data.payload,
      "institution/documents",
      "uapi"
    );

    if (response.data) {
      yield put(sagasActions.fillInstitution(response.data));
    }
  } catch (e) {
    console.log("E_SUBMIT_INSTITUTION_DOCS ->", e);
  }
}

export default function* rootSaga() {
  yield all([
    fork(requestSignInSaga),
    fork(signUpRequestSaga),
    fork(getAccountSaga),
    fork(verifyPhoneSaga),
    fork(submitProfileSaga),
    fork(getAcceptedIDTypesSaga),
    fork(uploadFileSaga),
    fork(updateAccountSaga),
    fork(disabledOtpSaga),
    fork(enableOtpSaga),
    fork(submitChangePasswordSaga),
    fork(uploadToJumioSaga),
    fork(fetchTerritoriesSaga),
    fork(updateProfileSaga),
    fork(requestApiKeySaga),
    fork(fetchApiKeysSaga),
    fork(fetchApiSummarySaga),
    fork(submitVerificationCodeSaga),
    fork(resendVerificationCodeSaga),
    fork(requestPasswordResetSaga),
    fork(completePasswordResetSaga),
    fork(submitIpConfirmationSaga),
    fork(requestSignOutSaga),
    fork(deleteApiKeySaga),
    fork(requestAcceptNewTermsSaga),
    fork(fetchCountriesSaga),
    fork(fetchNationalitiesSaga),
    fork(fetchOccupationsSaga),
    fork(fetchPhoneCodesSaga),
    fork(createInstitutionSaga),
    fork(submitBankDetailsSaga),
    fork(submitInstitutionDirectorsSaga),
    fork(fetchInstitutionSaga),
    fork(submitInstitutionDocumentsSaga),
  ]);
}
